function UpNextCard({ label, labelColor, bout }) {
  if (!bout) return null;
  return (
    <div className="flex-1 bg-dark-800 border border-dark-500 rounded-xl p-3 text-center min-w-0">
      <div className="font-display text-[10px] font-bold tracking-widest mb-1" style={{ color: labelColor }}>{label}</div>
      <div className="font-display text-sm font-bold whitespace-nowrap overflow-hidden text-ellipsis">
        <span style={{ color: "#EF9A9A" }}>{bout.fighterRed}</span>
        <span className="text-gray-600"> vs </span>
        <span style={{ color: "#64B5F6" }}>{bout.fighterBlue}</span>
      </div>
    </div>
  );
}

// Shared "NEXT UP" / "ON DECK" preview row for ref-facing pool views (RefPool, RefBout).
export default function UpNextRow({ nextBout, onDeckBout }) {
  if (!nextBout && !onDeckBout) return null;
  return (
    <div className="flex gap-2">
      <UpNextCard label="NEXT UP" labelColor="#fff" bout={nextBout} />
      <UpNextCard label="ON DECK" labelColor="#9CA3AF" bout={onDeckBout} />
    </div>
  );
}
